import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
} from "chart.js";
import { Link } from "react-router-dom";
import getAllAdmin from "../../hooks/getAllAdmin";
import {
  Row,
  Col,
  Card,
  Typography,
  Table,
  Tag,
  Button,
  Select,
  Space,
} from "antd";
import {
  UsergroupAddOutlined,
  FileTextOutlined,
  AppstoreAddOutlined,
  CreditCardOutlined,
} from "@ant-design/icons";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement
);

const { Title, Text } = Typography;
const { Option } = Select;

const AdminDashboard = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [getAllData, setGetAllData] = useState({});
  const [latestOrders, setLatestOrders] = useState([]);
  const user = JSON.parse(localStorage.getItem("admin"));

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_APIURL;
    const fetchLatestOrders = async () => {
      const res = await fetch(`${baseUrl}/vendor/getallorder`, {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      });
      const response = await res.json();

      if (response.status_code === 200) {
        setLatestOrders(response.data.slice(-3));
      }
    };
    const allData = async () => {
      const res = await getAllAdmin("admin/getdashboarddetails");
      if (res.status_code === 200) {
        setGetAllData(res);
      }
    };
    fetchLatestOrders();
    allData();
  }, []);

  useEffect(() => {
    const getAllPlans = async () => {
      let res = await getAllAdmin("admin/getallvendorplan");
      if (res.status_code === 200) {
        setData(res.data);
      }
    };
    getAllPlans();
  }, []);

  const columns = [
    {
      title: t("Order_Id"),
      dataIndex: "id",
    },
    {
      title: t("Vendor"),
      dataIndex: "store_name",
      render: (text) => text || "",
    },
    {
      title: t("Plan"),
      dataIndex: "plan_name",
    },
    {
      title: t("Transaction_id"),
      dataIndex: "transaction_id",
    },
    {
      title: t("Status"),
      dataIndex: "status",
      render: (status) =>
        status === 1 ? (
          <Tag color="green">{t("Active")}</Tag>
        ) : (
          <Tag color="red">{t("Pending")}</Tag>
        ),
    },
  ];

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
  };

  const subscriptionData = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        label: t("Subscriptions"),
        backgroundColor: "rgba(127, 143, 244,1)",
        data: getAllData?.monthWiseSubscriptions_arr,
      },
    ],
  };

  const earningsData = {
    labels: subscriptionData.labels,
    datasets: [
      {
        label: t("Earnings"),
        backgroundColor: "rgba(255, 138, 101,1)",
        data: getAllData?.monthWiseEarnings_arr,
      },
    ],
  };

  const stats = [
    {
      icon: <UsergroupAddOutlined style={{ fontSize: 24 }} />,
      label: t("Vendors"),
      value: getAllData?.vendors?.count,
      link: "/admin/vendors",
    },
    {
      icon: <FileTextOutlined style={{ fontSize: 24 }} />,
      label: t("V_allOrder_title"),
      value: getAllData?.orders?.count,
      link: "/admin/orders",
    },
    {
      icon: <AppstoreAddOutlined style={{ fontSize: 24 }} />,
      label: t("Domain_Requests"),
      value: getAllData?.domainrequests?.count,
      link: "/admin/domain",
    },
    {
      icon: <CreditCardOutlined style={{ fontSize: 24 }} />,
      label: t("All_Plans"),
      value: getAllData?.expiredsubscriptions?.count,
      link: "/admin/plan/all-plans",
    },
  ];

  return (
    <div className="p-4">
      <Row gutter={[16, 16]}>
        {stats.map((stat, index) => (
          <Col xs={24} sm={12} lg={6} key={index}>
            <Link to={stat.link}>
              <Card hoverable>
                <Space direction="horizontal">
                  {stat.icon}
                  <div>
                    <Text type="secondary">{stat.label}</Text>
                    <Title level={4}>{stat.value}</Title>
                  </div>
                </Space>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>

      <Card
        title={t("Latest_Orders")}
        extra={<Link to="/admin/orders">{t("View_All")}</Link>}
        className="my-6"
      >
        <Table
          columns={columns}
          dataSource={data.slice(0, 3)}
          pagination={false}
          rowKey="id"
        />
      </Card>

      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <Card title={t("Subscriptions")}>
            <div style={{ height: 350 }}>
              <Bar data={subscriptionData} options={chartOptions} />
            </div>
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card title={t("Earnings")}>
            <div style={{ height: 350 }}>
              <Bar data={earningsData} options={chartOptions} />
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AdminDashboard;
